import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Link as RouterLink } from "react-router-dom";
import { BookingRequest } from "../components/BookingRequest";
import { Header } from "../components/header/Header";
import { Passes } from "../components/Passes";
import { UpcomingEventsWidget } from "../components/UpcomingEventsWidget";
import { AboutColaHome } from "../components/AboutColaHome";
import SocialMetaTags from "../components/header/SocialMetaTags";

const Home = () => {
  return (
    <>
      <SocialMetaTags title="Welcome to The Cola St. Louis" />
      <Header />
      <Container spacing={2}>
        <Box sx={{ mb: 2 }}></Box>

        {/* Appointment & Private Booking Requests - Immediate Action */}
        <BookingRequest />

        {/* Upcoming Events - Tickets Available */}
        <UpcomingEventsWidget />

        {/* Quick Actions */}
        <Grid container spacing={2} sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12} md={4}>
            <Button
              component={RouterLink}
              to="/checked-in"
              variant="contained"
              fullWidth
              size="large"
              color="secondary"
              sx={{ height: '100%', py: 2 }}
            >
              Check In
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
             <Button
              component={RouterLink}
              to="/events"
              variant="contained"
              fullWidth
              size="large"
              color="info"
              sx={{ height: '100%', py: 2 }}
            >
              Get Event Tickets
            </Button>
          </Grid>
          <Grid item xs={12} md={4}>
             <Button
              component={RouterLink}
              to="/share"
              variant="contained"
              fullWidth
              size="large"
              color="warning"
              sx={{ height: '100%', py: 2 }}
            >
              Share The Cola
            </Button>
          </Grid>
        </Grid>

        {/* Membership Passes */}
        <Passes />

        {/* About / Info */}
        <AboutColaHome />

      </Container>
    </>
  );
};

export default Home;
